import { useCallback } from 'react';

const FOCUSABLE_SELECTOR = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

export const useFocusMainContent = () => {
    return useCallback(() => {
        const mainContent = document.getElementById('main-content');
        if (!mainContent) return;

        const focusableElement = mainContent.querySelector(FOCUSABLE_SELECTOR) as HTMLElement;
        (focusableElement || mainContent).focus();
    }, []);
};
